if (!window.Eurus.loadedScript.has('grouped-options.js')) {
  window.Eurus.loadedScript.add('grouped-options.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xGroupedOptions', (sectionId) => ({
        onGroupVariantChange(el) {
          const variantId = el.dataset.variantId || el.value;
          const productId = el.dataset.productId;
          const productUrl = el.dataset.productUrl;
          const isAvailable = el.dataset.available === 'true';
          const root = el.closest('#choose-options-content') || document;

          const variantInputs = root.querySelectorAll(
            `[id='update-variant-${sectionId}']`,
          );
          const productInputs = root.querySelectorAll(
            "input[name='product-id']",
          );
          const installmentInputs = root.querySelectorAll(
            `#product-form-installment-${sectionId} input[name='id']`,
          );
          const addToCartButtons = root.querySelectorAll(
            `[id='x-atc-button-${sectionId}']`,
          );
          const priceMap = root.querySelector(
            `#grouped-price-map-${sectionId}`,
          );
          const priceDestination = root.querySelector(`#price-${sectionId}`);
          const viewDetailLink = root.querySelector('a.view_product_detail');

          // Update hidden variant id
          variantInputs.forEach((input) => (input.value = variantId));

          // Update hidden product id
          productInputs.forEach((input) => (input.value = productId));

          // Swap price HTML
          if (priceMap && priceDestination && priceMap.content) {
            const node = priceMap.content.querySelector(
              `[data-vid='${variantId}']`,
            );
            if (node) {
              priceDestination.innerHTML = node.innerHTML;
            }
          }

          // Sync payment terms
          installmentInputs.forEach((input) => (input.value = variantId));

          // Toggle ATC buttons
          addToCartButtons.forEach((button) => {
            const text = button.querySelector('.button-text');
            if (isAvailable) {
              button.removeAttribute('disabled');
              text.textContent = window.Eurus.atc;
            } else {
              button.setAttribute('disabled', 'disabled');
              text.textContent = window.Eurus.oos;
            }
          });

          // Update "view full details" link
          if (viewDetailLink && productUrl) {
            viewDetailLink.setAttribute('href', productUrl);
          }
        },

        init() {
          const checkedInput = this.$el.querySelector(
            'input[name=grouped-size]:checked',
          );
          const isAvailable = checkedInput
            ? checkedInput.dataset.available === 'true'
            : true;

          const addToCartButtons = this.$el.querySelectorAll(
            `[id='x-atc-button-${sectionId}']`,
          );
          addToCartButtons.forEach((button) => {
            const text = button.querySelector('.button-text');
            if (isAvailable) {
              button.removeAttribute('disabled');
              text.textContent = window.Eurus.atc;
            } else {
              button.setAttribute('disabled', 'disabled');
              text.textContent = window.Eurus.oos;
            }
          });
        },
      }));
    });
  });
}
